import { useOrg } from 'contexts/OrgContext'
import { ADMIN_ORG } from 'contexts/UserContext'
import { isZeusEnvironment } from 'utils/environment'

/**
 * True only when the app is the Zeus build AND the currently-selected org is the
 * Zeus operational/admin org (VITE_AUTH_ADMIN_ORG === 'Zeus').
 *
 * Keys off the currently-viewed org (OrgContext), NOT user.org: the Zeus
 * superadmin's home org IS the admin org, so user.org === ADMIN_ORG is always
 * true and would wrongly apply to every org they view. The isZeusEnvironment()
 * guard keeps this false in commercial, where ADMIN_ORG is 'Tactic'.
 */
const useIsZeusAdminOrg = (): boolean => {
  const { org: currentOrg } = useOrg()
  return isZeusEnvironment() && !!(ADMIN_ORG && currentOrg === ADMIN_ORG)
}

export default useIsZeusAdminOrg
